import { gql } from "@apollo/client";

const CREATE_TOR = gql`
    mutation createToR($laID: String!, $studyPeriodStart: String, $studyPeriodEnd: String){
        createToR(laID: $laID, studyPeriodStart: $studyPeriodStart, studyPeriodEnd: $studyPeriodEnd) 
  }
`;

export default CREATE_TOR;
